import { render, staticRenderFns } from "./ConfigSystemGeneralProperties.vue?vue&type=template&id=06300bba&scoped=true&"
import script from "./ConfigSystemGeneralProperties.vue?vue&type=script&lang=js&"
export * from "./ConfigSystemGeneralProperties.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSystemGeneralProperties.vue?vue&type=style&index=0&id=06300bba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06300bba",
  null
  
)

export default component.exports